document.addEventListener("DOMContentLoaded", function() {

  let _recoLoading = false;

  // =====================
  // PROGRESSION
  // =====================

  function updateProgression(cartTotalCents) {
    const progressEl = document.querySelector('.cart-barre-progression');
    if (!progressEl) return;

    const t1 = progressEl.querySelector('.etape-1-texte');
    const t1v = progressEl.querySelector('.etape-1-validation');
    const t2 = progressEl.querySelector('.etape-2-texte');
    const t2v = progressEl.querySelector('.etape-2-validation');
    const icon1 = progressEl.querySelector('.icon-etape-1');
    const icon2 = progressEl.querySelector('.icon-etape-2');

    if (t1 && !t1.dataset.originalHtml) t1.dataset.originalHtml = t1.innerHTML;
    if (t2 && !t2.dataset.originalHtml) t2.dataset.originalHtml = t2.innerHTML;

    const etape1 = parseInt(progressEl.dataset.etape1);
    const etape2 = parseInt(progressEl.dataset.etape2) || 0;
    const hasEtape2 = progressEl.dataset.hasEtape2 === 'true';
    const cartTotal = cartTotalCents;

    [t1, t1v, t2, t2v].forEach(el => el?.classList.remove('active'));
    icon1?.classList.remove('active');
    icon2?.classList.remove('active');

    if (cartTotal < etape1) {
      const restant = ((etape1 - cartTotal) / 100).toFixed(2).replace('.00', '').replace('.', ',') + '€';
      if (t1) t1.innerHTML = t1.dataset.originalHtml.replace('(prix)', restant);
      t1?.classList.add('active');
    } else if (!hasEtape2 || cartTotal >= etape2) {
      hasEtape2 ? t2v?.classList.add('active') : t1v?.classList.add('active');
      icon1?.classList.add('active');
      if (hasEtape2) icon2?.classList.add('active');
    } else {
      const restant = ((etape2 - cartTotal) / 100).toFixed(2).replace('.00', '').replace('.', ',') + '€';
      if (t2) t2.innerHTML = t2.dataset.originalHtml.replace('(prix)', restant);
      t1v?.classList.add('active');
      if (hasEtape2 && cartTotal >= etape1) t2?.classList.add('active');
      icon1?.classList.add('active');
    }

    const max = hasEtape2 ? etape2 : etape1;
    const pct = Math.min(100, Math.round((cartTotal / max) * 100));
    const barre = progressEl.querySelector('.barre');
    if (barre) barre.style.setProperty('--width-progression', pct + '%');
  }

  // =====================
  // RECOS
  // =====================

  function loadRecoProducts() {
    if (_recoLoading) return;
    const el = document.querySelector('.cart-recommandations__item');
    if (!el) return;

    _recoLoading = true;
    el.dataset.loaded = 'true';

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if (!cart.item_count) {
          _recoLoading = false;
          return;
        }

        const productIds = cart.items.map(i => i.product_id).join(',');
        const cartProductIds = cart.items.map(i => String(i.product_id));
        const container = el.closest('.cart-recommandations');
        const limit = parseInt(container.getAttribute('limit')) || 4;
        const firstId = productIds.split(',')[0];

        fetch(`/recommendations/products.json?product_id=${firstId}&limit=10`)
          .then(r => r.json())
          .then(data => {
            const products = data.products
              .filter(p => !cartProductIds.includes(String(p.id)))
              .slice(0, limit);

            if (!products.length) {
              container.style.display = 'none';
              _recoLoading = false;
              return;
            }

            el.innerHTML = products.map(product => {
              const variantTitle = product.variants[0]?.title !== 'Default Title' ? product.variants[0]?.title : '';
              const price = (product.variants[0].price / 100).toFixed(2) + '€';
              const img = product.images[0]?.src || product.featured_image || '';

              return `
                <div class="reco-card">
                  <a href="${product.url}"><img class="reco-img" src="${img}" alt="${product.title}"></a>
                  <div class="reco-info">
                    <p class="reco-title"><a href="${product.url}">${product.title}</a></p>
                    ${variantTitle ? `<p class="reco-subtitle">${variantTitle}</p>` : ''}
                    <div class="price-btn">
                      <p class="reco-price">${price}</p>
                      <button class="reco-btn" data-variant-id="${product.variants[0].id}">AJOUTER [ + ]</button>
                    </div>
                  </div>
                </div>
              `;
            }).join('');

            el.querySelectorAll('.reco-btn').forEach(btn => {
              btn.addEventListener('click', () => {
                btn.disabled = true;
                btn.textContent = '...';

                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
                })
                .then(r => r.json())
                .then(() => fetch('/cart?view=compare'))
                .then(r => r.json())
                .then(cart => {
                  el.dataset.loaded = '';
                  _recoLoading = false;
                  btn.disabled = false;
                  btn.textContent = 'AJOUTER [ + ]';

                  window._skipDrawerRecos = true;
                  document.documentElement.dispatchEvent(new CustomEvent('wetheme-toggle-right-drawer', {
                    detail: { type: 'cart', forceOpen: true, params: { cart } }
                  }));
                  setTimeout(() => {
                    window._skipDrawerRecos = false;
                    loadRecoProducts();
                  }, 600);
                })
                .catch(() => {
                  btn.disabled = false;
                  btn.textContent = 'AJOUTER [ + ]';
                  _recoLoading = false;
                });
              });
            });

            initRecoSlider(el);
            _recoLoading = false;
          })
          .catch(() => { _recoLoading = false; });
      })
      .catch(() => { _recoLoading = false; });
  }

  // =====================
  // SLIDER
  // =====================

  function initRecoSlider(slider) {
    const container = slider.closest('.cart-recommandations');
    const leftBtn = container.querySelector('.reco-left-arrow');
    const rightBtn = container.querySelector('.reco-right-arrow');

    function updateArrows() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      leftBtn.classList.toggle('disabled', slider.scrollLeft <= 0);
      rightBtn.classList.toggle('disabled', slider.scrollLeft >= maxScroll - 1);
    }

    function getCardWidth() {
      const card = slider.querySelector('.reco-card');
      if (!card) return slider.clientWidth;
      return card.offsetWidth + parseInt(getComputedStyle(slider).gap || 15);
    }

    rightBtn.addEventListener('click', () => {
      if (rightBtn.classList.contains('disabled')) return;
      slider.scrollBy({ left: getCardWidth(), behavior: 'smooth' });
    });

    leftBtn.addEventListener('click', () => {
      if (leftBtn.classList.contains('disabled')) return;
      slider.scrollBy({ left: -getCardWidth(), behavior: 'smooth' });
    });

    slider.addEventListener('scroll', updateArrows);
    updateArrows();
  }

  // =====================
  // EVENTS
  // =====================

  document.documentElement.addEventListener('wetheme-toggle-right-drawer', (e) => {
    if (e.detail?.type !== 'cart') return;
    if (window._skipDrawerRecos) return;
    clearTimeout(window._drawerTimeout);
    window._drawerTimeout = setTimeout(() => {
      const el = document.querySelector('.cart-recommandations__item');
      if (el) el.dataset.loaded = '';
      _recoLoading = false;
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          updateProgression(cart.total_price);
          loadRecoProducts();
        });
    }, 400);
  });

  document.documentElement.addEventListener('wetheme-cart-update', (e) => {
    if (e.detail?.cart) {
      updateProgression(e.detail.cart.total_price);
    }
  });

});